export const CertificateCourseModel = [
    {
        credentialId: "78EMBBHY6KAZ",
        credentialUrl: "https://www.coursera.org/account/accomplishments/certificate/78EMBBHY6KAZ",
        instructor: "University of California San Diego",
        issuedDate: new Date("2020-08-07"),
        issuedOrganization: "Coursera",
        name: "Introduction to Big Data"
    }, {
        credentialId: "KC56PSU2KU4N",
        credentialUrl:  "https://www.coursera.org/account/accomplishments/certificate/KC56PSU2KU4N",
        instructor: "University of California, Davis",
        issuedDate: new Date("2020-08-16"),
        issuedOrganization: "Coursera",
        name: "SQL for Data Science"
    }, {
        credentialId: "KGXLK8KPU52L",
        credentialUrl: "https://www.coursera.org/account/accomplishments/certificate/KGXLK8KPU52L",
        instructor: "Learn Quest",
        issuedDate: new Date("2021-01-03"),
        issuedOrganization: "Coursera",
        name: "Introduction to Programming in Swift 5",
    }, {
        credentialId: "L9QC5ATSGN87",
        credentialUrl: "https://www.coursera.org/account/accomplishments/certificate/L9QC5ATSGN87",
        instructor: "Coursera Project Network",
        issuedDate: new Date("2021-05-03"),
        issuedOrganization: "Coursera",
        name: "Seeking Investment Alpha"
    }, {
        credentialId: "W8REAGE3WV6D",
        credentialUrl: "https://www.coursera.org/account/accomplishments/certificate/W8REAGE3WV6D",
        instructor: "Indian School of Business",
        issuedDate: new Date("2021-07-16"),
        issuedOrganization: "Coursera",
        name: "A Life of Happiness and Fulfillment"
    }, {
        credentialId: "ZX4E5P5BMWCP",
        credentialUrl: "https://www.coursera.org/account/accomplishments/certificate/ZX4E5P5BMWCP",
        instructor: "University of Michigan",
        issuedDate: new Date("2022-05-16"),
        issuedOrganization: "Coursera",
        name: "Inspiring and Motivating Individuals"
    }, {
        credentialId: "UML4PLNMDYBZ",
        credentialUrl: "https://www.coursera.org/account/accomplishments/certificate/UML4PLNMDYBZ",
        instructor: "Coursera Project Network",
        issuedDate: new Date("2023-03-17"),
        issuedOrganization: "Coursera",
        name: "Preparation for Job Interviews",
    }, {
        credentialId: "KTY8UXS2FBXW",
        credentialUrl: "https://www.coursera.org/account/accomplishments/certificate/KTY8UXS2FBXW",
        instructor: "meta",
        issuedDate: new Date("2023-04-17"),
        issuedOrganization: "Coursera",
        name: "Introduction to iOS Mobile Application Development"
    }, {
        credentialId: "J2VQ3Y72CYNP",
        credentialUrl: "https://www.coursera.org/account/accomplishments/certificate/J2VQ3Y72CYNP",
        instructor: "Coursera Project Network",
        issuedDate: new Date("2023-04-27"),
        issuedOrganization: "Coursera",
        name: "Compare Stock Returns with Google Sheets"
    }, {
        credentialId: "72EGLRFBKQU7",
        credentialUrl: "https://www.coursera.org/account/accomplishments/certificate/72EGLRFBKQU7",
        instructor: "Meta",
        issuedDate: new Date("2023-06-12"),
        issuedOrganization: "Coursera",
        name: "Version Control",
        
    }, {
        credentialId: "6RYNS6FEDB3L",
        credentialUrl: "https://www.coursera.org/account/accomplishments/certificate/6RYNS6FEDB3L",
        instructor: "Meta",
        issuedDate: new Date("2023-06-18"),
        issuedOrganization: "Coursera",
        name: "Programming Fundamentals in Swift"
    }, {
        credentialId: "K6QASR6LWFP5",
        credentialUrl: "https://www.coursera.org/account/accomplishments/certificate/K6QASR6LWFP5",
        instructor: "Meta",
        issuedDate: new Date("2023-06-24"),
        issuedOrganization: "Coursera",
        name: "Principles of UX/UI Design"
    }, {
        credentialId: "LLAKYSACPPAM",
        credentialUrl: "https://www.coursera.org/account/accomplishments/records/LLAKYSACPPAM",
        instructor: "Meta",
        issuedDate: new Date("2023-07-01"),
        issuedOrganization: "Coursera",
        name: "Create the Use Interface with SwiftUI",
    }, {
        credentialId: "WTBMY7TNY4KX",
        credentialUrl: "https://www.coursera.org/account/accomplishments/certificate/WTBMY7TNY4KX",
        instructor: "Meta",
        issuedDate: new Date("2023-11-02"),
        issuedOrganization: "Coursera",
        name: "Advanced Programming in Swift"
    }, {
        credentialId: "JEV2H7LV97HL",
        credentialUrl: "https://www.coursera.org/account/accomplishments/certificate/JEV2H7LV97HL",
        instructor: "Meta",
        issuedDate: new Date("2023-11-04"),
        issuedOrganization: "Coursera",
        name: "Working with Data in iOS"
    }, {
        credentialId: "F3GUF8DPY7CH",
        credentialUrl: "https://www.coursera.org/account/accomplishments/certificate/F3GUF8DPY7CH",
        instructor: "Meta",
        issuedDate: new Date("2023-11-08"),
        issuedOrganization: "Coursera",
        name: "Mobile Development and JavaScript"
    }, {
        credentialId: "9MZDWXWRCL5A",
        credentialUrl: "https://www.coursera.org/account/accomplishments/certificate/9MZDWXWRCL5A",
        instructor: "Meta",
        issuedDate: new Date("2023-11-09"),
        issuedOrganization: "Coursera",
        name: "React Basics"
    }, {
        credentialId: "KGSUA2NPM5UX",
        credentialUrl: "https://www.coursera.org/account/accomplishments/certificate/KGSUA2NPM5UX",
        instructor: "Meta",
        issuedDate: new Date("2023-11-17"),
        issuedOrganization: "Coursera",
        name: "React Native",
    }, {
        credentialId: "LAXK86HCBBVT",
        credentialUrl: "https://www.coursera.org/account/accomplishments/certificate/LAXK86HCBBVT",
        instructor: "Meta",
        issuedDate: new Date("2023-11-23"),
        issuedOrganization: "Coursera",
        name: "Coding Interview Preparation",
    }, {
        credentialId: "EZFPBSSDZQBR",
        credentialUrl: "https://www.coursera.org/account/accomplishments/certificate/EZFPBSSDZQBR",
        instructor: "Meta",
        issuedDate: new Date("2023-11-25"),
        issuedOrganization: "Coursera",
        name: "iOS App Capstone",
    }, {
        credentialId: "MQ8NPLZRFWYN",
        credentialUrl: "https://www.coursera.org/account/accomplishments/records/MQ8NPLZRFWYN",
        instructor: "Meta",
        issuedDate: new Date("2024-01-26"),
        issuedOrganization: "Coursera",
        name: "Introduction to Android Mobile Application Development"
    }, {
        credentialId: "J9LXM74E5SWV",
        credentialUrl: "https://www.coursera.org/account/accomplishments/records/J9LXM74E5SWV",
        instructor: "Meta",
        issuedDate: new Date("2024-01-30"),
        issuedOrganization: "Coursera",
        name: "Programming Fundamentals in Kotlin"
    }, {
        credentialId: "TPZM6HZJCEFE",
        credentialUrl: "https://www.coursera.org/account/accomplishments/records/TPZM6HZJCEFE",
        instructor: "Meta",
        issuedDate: new Date("2024-02-08"),
        issuedOrganization: "Coursera",
        name: "Create the User Interface in Android Studio"
    }, {
        credentialId: "ERJNSNMWXQHU",
        credentialUrl: "https://www.coursera.org/account/accomplishments/certificate/ERJNSNMWXQHU",
        instructor: "Meta",
        issuedDate: new Date("2024-02-24"),
        issuedOrganization: "Coursera",
        name: "Advanced Programming in Kotlin"
    }, {
        credentialId: "YK7UJLEHHN87",
        credentialUrl: "https://www.coursera.org/account/accomplishments/verify/YK7UJLEHHN87",
        instructor: "Meta",
        issuedDate: new Date("2024-03-27"),
        name: "Working with Data in Android"
    }
]
